import {Box, Button, Grid2, Typography} from '@mui/material';
import React from 'react';
import myImage from "../../assets/images/news1.png";
import myImage3 from "../../assets/images/news2.png";
import myImage2 from "../../assets/images/news3.png";
import './OurTeam.css'

const OurTeam: React.FC = () => {
    return (
        <Grid2 id='our-team-component' container justifyContent="center" alignItems="center" spacing={{xs: 1, md: 2}}
               columns={{xs: 10, sm: 10, md: 10}}>
            <Grid2 size={{xs:12}}>
                <Typography className='nameSection'>
                    Our team
                </Typography>
            </Grid2>
            <Grid2 container justifyContent="center"
                   spacing={{xs: 1, md: 2}}
                   columns={{xs: 12}}
                   size={{xs:12}}>
                <Grid2 size={{xs: 10, sm: 8, md: 4 , lg: 3}}>
                    <Box className='box' textAlign="center">
                        <Box className='parentImg comingSoonImg'>
                            <img src={myImage} alt="Coming to ICE"
                                 style={{width: '100%', height: 'auto'}}/>
                        </Box>
                        <Box className={'parent-name'}>
                            <Typography className={'subtitle'}>Founder and CEO:</Typography>
                            <Typography className={'title'}>Carmi Halachmi</Typography>
                        </Box>
                    </Box>
                </Grid2>
                <Grid2 size={{xs: 10, sm: 8, md: 4 , lg: 3}}>
                    <Box className='box' textAlign="center">
                        <Box className='parentImg comingSoonImg'>
                            <img src={myImage} alt="Coming to ICE"
                                 style={{width: '100%', height: 'auto'}}/>
                        </Box>
                        <Box className={'parent-name'}>
                            <Typography className={'subtitle'}>CoFounder:</Typography>
                            <Typography className={'title'}>Shuki Barak</Typography>
                        </Box>
                    </Box>
                </Grid2>
            </Grid2>
        </Grid2>
    );
};

export default OurTeam;